var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sun-template',{attrs:{"country-of-residence":_vm.countryOfResidence,"city-of-residence":_vm.cityOfResidence,"planned-high-u-v-exposure":_vm.plannedHighUVExposure,"temperature-contrast":_vm.temperatureContrast,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }